/**
 * Keeps each product title in a recommendation row the height of its tallest title.
 */
class CustomKitGrid extends HTMLElement {
  #gridWidth;

  #resizeObserver = new ResizeObserver(([entry]) => {
    const width = entry.contentRect.width;

    if (width === this.#gridWidth) return;

    this.#gridWidth = width;
    this.#scheduleTitleAlignment();
  });

  #animationFrame;

  connectedCallback() {
    this.#resizeObserver.observe(this);
    document.fonts?.ready?.then(() => this.#scheduleTitleAlignment());
    this.#scheduleTitleAlignment();
  }

  disconnectedCallback() {
    this.#resizeObserver.disconnect();
    cancelAnimationFrame(this.#animationFrame);
  }

  #scheduleTitleAlignment() {
    cancelAnimationFrame(this.#animationFrame);
    this.#animationFrame = requestAnimationFrame(() => this.#alignTitles());
  }

  #alignTitles() {
    const titles = [...this.querySelectorAll('.site-kit h3')];

    titles.forEach((title) => {
      title.style.minHeight = '';
    });

    const tallestTitle = Math.max(0, ...titles.map((title) => title.getBoundingClientRect().height));

    titles.forEach((title) => {
      title.style.minHeight = `${tallestTitle}px`;
    });
  }
}

if (!customElements.get('site-kit-grid')) {
  customElements.define('site-kit-grid', CustomKitGrid);
}
